import { BaseConfig } from '../ServiceConfig';

export interface ListingConfiguration extends BaseConfig {
  '@type': 'type.googleapis.com/terra.v1.ListingServiceConfigData';
  url: string;
  channel: string;
  terminal: string;
}

export const ListingConfigurationFields: (keyof ListingConfiguration)[] = [
  'url',
  'channel',
  'terminal',
];

export const BlankListingConfiguration: ListingConfiguration = {
  '@type': 'type.googleapis.com/terra.v1.ListingServiceConfigData',
} as ListingConfiguration;
